import { TPermissionChecksState, TPermissionCheckStatus } from './types';

export function getPermissionStatus(state: TPermissionChecksState) {
  return (permissionId: number): TPermissionCheckStatus | undefined => state.checks[permissionId];
}

export function getIsHidden(state: TPermissionChecksState) {
  return (permissionId: number): boolean => {
    const status = state.checks[permissionId];

    if (status === undefined || status === 'pending') {
      return true;
    }

    return !status;
  };
}
